import { Link, useLocation } from "react-router-dom";

const Navigation = ({ defaultVehicleId, navClasses }) => {
  const location = useLocation();

  const isDashboardActive = location.pathname === "/dashboard";
  const isVehicleHealthActive = /^\/vehicle\/\d+$/.test(location.pathname);

  return (
    <>
      <nav className={navClasses}>
        <Link
          to="/dashboard"
          className={`px-4 py-2 bg-blue-600 text-white hover:text-gray-900 nav_link_parent nav_link_text ${isDashboardActive ? 'nav_link_active' : ''}`}
        >
          <i className="ti ti-layout-dashboard"></i> Dashboard
        </Link>

        <Link
          to={`/vehicle/${defaultVehicleId}`}
          className={`hover:text-gray-900 nav_link_parent nav_link_text ${isVehicleHealthActive ? 'nav_link_active' : ''}`}
        >
          <i className="ti ti-truck-delivery"></i> Vehicle Health
        </Link>
      </nav>
    </>
  );
};

export default Navigation;